import { useState, useEffect, useRef } from "react";
import { getRequest } from "../../utils/apiCall";
import { Row, Col, Spinner, Button} from 'reactstrap';
import styles from './Categories.module.scss';
import { Toast } from 'primereact/toast';

const CATEGORIES_URL = 'api/v1/categories';

export default function Categories({handleCategorySelected}) {
    const toast = useRef(null);

    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [back, setBack] = useState([]);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

     const handleBackButtom = async () => {

        try {
            const response = await getRequest(CATEGORIES_URL,{
                params: {
                    parent_id: back[back.length -1 ] ,
                    limit:50,
                    is_feature:''
                }
            });
            setCategories(response.data.data);
            setBack(back.slice(0 , back.length -1));
            setIsLoading(false);
        }
        catch (error){
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message)
              } 
              setIsLoading(false);
            }
        finally{
            setIsLoading(false);

        }
     }

    const handleCategoryClick = async (catData = null) => {
        setIsLoading(true);

        try {
            if (catData != null && !catData.has_child) {
                handleCategorySelected({id:catData.id, title: catData.title, listing_price: catData.listing_price, sell_commission: catData.sell_commission});
                return
            }
        if(catData) {
            setBack([...back, catData.pid]);
        }


            const response = await getRequest(CATEGORIES_URL,{
                params: {
                    parent_id: catData == null ? 0 : catData.id ,
                    limit:50,
                    is_feature:''
                }
            });
            setCategories(response.data.data);
            setIsLoading(false);
        } 
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message)
              } 
              setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleCategoryClick();   
    },[]);
    

  return (
    <div className="container-xxl">
        <Toast ref={toast} position="top-center" />

        <Row>
            <Col md={12}>
                {
                    back.length > 0 &&
                        <Button 
                            className={`text-decoration-none`}
                            onClick={() => handleBackButtom()}
                        >
                            <i className="bi bi-arrow-left"></i>
                        </Button>
                }
            </Col>
        </Row>
        <Row className={`py-3`}>
            <Col md={12}>
                <div className={`${styles.wrapper} d-flex flex-row flex-wrap justify-content-center`}>
                    {
                        isLoading ? (
                            <>
                                <Spinner color='primary' className='mx-auto'>
                                    Loading...
                                </Spinner>
                            </>
                        ) : (
                            categories &&
                                categories.map((catData) => (
                                    <a 
                                        key={catData.id}
                                        id={catData.id} 
                                        className={`${styles.categoryItemBox} mx-2 text-decoration-none fw-semibold`}
                                        onClick={() => handleCategoryClick(catData)}
                                    >
                                        {
                                            // <Category listData={catData} />
                                            <div id={catData.id} className={`${styles.categoryItem}`}>
                                                <img className={` img-fluid ${styles.coverImage}`} src={`${!catData.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${catData.image}`}`} />
                                                <div  className={` text-center p-3`}>
                                                    <div className={`py-1 ${styles.title}`}>{catData.title}</div>
                                                </div>
                                            </div>
                                        }
                                    </a>

                        ))
                        )
                    }
                </div>
            </Col>
        </Row>
     </div>
  )
}
